import { ListingPlansDeTravail } from '@components/listing-plans-de-travail/models';
import { Block } from '@shared/models';

export const listingPlansDeTravailMock: Block<ListingPlansDeTravail> = {
  type: 'listing-plans-de-travail',
  data: {
    breathingText: 'Nos meubles sont fabriqués en France, garantis 10 ans et livrés chez vous [[déjà montés]]',
  },
};
